import { render, staticRenderFns } from "./DetailTemplateCardView.vue?vue&type=template&id=b0003d40"
import script from "./DetailTemplateCardView.vue?vue&type=script&lang=js"
export * from "./DetailTemplateCardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports